import UserService from './UserService';

import apiService from '../Api';

export default new UserService(apiService);
